import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HandsetService } from '../../../core/services/handset.service';

@Component({
standalone: false,
  selector: 'app-error-dialog',
  styleUrls: ['./error-dialog.component.scss'],
  templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
  public title: string;
  public msg: string;
  public phoneNumber = '222610620';
  public mail = 'kontakt@payka.pl';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public handsetService: HandsetService) {
    if (!!data.error && !!data.error.errorHash) {
      console.error('Error code: ' + data.error.errorHash);
    } else {
      console.error('Unknown error');
    }
    if (!!data.title) {
      this.title = data.title;
    }

    if (!!data.msg) {
      this.msg = data.msg;
    }
  }

  onCall() {
    window.location.href = `tel:${this.phoneNumber}`;
  }

  public onReport(): void {
    const message =
      'Cześć, proszę o sprawdzenie błędu ' +
      (this.data?.error?.errorHash || '...') +
      ', napotkanego podczas korzystania z aplikacji.';

    window.location.href = 'mailto:' + this.mail + '?subject=' + 'Błąd' + '&body=' + message;

  }
}
